<app-view-item *ngIf="readonly" [text]="selected?.code" [borderless]="borderless"></app-view-item>
<nz-select *ngIf="!readonly" #selector nzShowSearch nzServerSearch [nzAllowClear]="true" [nzBackdrop]="addBackdrop"
  [nzFilterOption]="nzFilterOption" (nzOnSearch)="search($event)" (nzOpenChange)="search('')"
  (nzScrollToBottom)="loadMore()" [nzCustomTemplate]="displayTpl" [(ngModel)]="value"
  (ngModelChange)="valueChanged($event)" (keydown)="handleKeyDown($event)" (click)="handleClick($event)"
  [nzDropdownMatchSelectWidth]="false" [nzBorderless]="borderless" nzPlacement="bottomLeft" class="width-100">
  <ng-template #displayTpl let-selected>
    <span>{{ selected.nzLabel }}</span>
    <small>({{ taxRate | percent: '1.2-2' }})</small>
  </ng-template>
  <ng-container *ngFor="let o of list">
    <nz-option *ngIf="!searching" [nzValue]="getValue(o)" [nzLabel]="o.code" nzCustomContent>
      <div>
        <div class="text-gray-500">{{ getTaxCategoryLabel(o) }}</div>
        <div>
          <span>{{ o.code }}</span>
          <span>: </span>
          <span class="text-grey-dark">
            {{ o.rate | percent: '1.2-2' }}
          </span>
        </div>
      </div>
    </nz-option>
  </ng-container>
</nz-select>
<ng-template #loadingTpl>
  <div *ngIf="searching">
    <nz-spin></nz-spin>
    Loading
  </div>
</ng-template>
